import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { PaymentSystem } from './payment-system.interface';
import { PaymentSystemService } from './payment-system.service';

const service = new PaymentSystemService();

export interface PaymentSystemState {
   paymentSystems: Array<PaymentSystem>;
}

const PaymentSystemStore: Module<PaymentSystemState, StoreState> = {
   namespaced: true,
   state: {
      paymentSystems: [],
   },
   getters: {},
   mutations: {
      SET_PAYMENT_SYSTEMS(state, paymentSystems: Array<PaymentSystem>) {
         state.paymentSystems = paymentSystems;
      },
   },
   actions: {
      async getPaymentSystems(context, query?: LocationQuery) {
         const response = await service.getPaymentSystems(query);
         context.commit('SET_PAYMENT_SYSTEMS', response.data);
         return response.data;
      },
   },
};

export default PaymentSystemStore;
